export const migrateSelectionBox = (boxGraph, box) => {
    const isInvalid = (pointer) => pointer.targetAddress.match({
        none: () => true,
        some: address => boxGraph.findVertex(address).isEmpty()
    });
    if (isInvalid(box.selectable) || isInvalid(box.selection)) {
        console.debug("Migrate remove broken 'SelectionBox'");
        boxGraph.beginTransaction();
        box.delete();
        boxGraph.endTransaction();
    }
};
